import { render, staticRenderFns } from "./PayfactoForm.vue?vue&type=template&id=4370fe24&"
import script from "./PayfactoForm.vue?vue&type=script&lang=js&"
export * from "./PayfactoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports